import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(0.8, 0),
    minWidth: '250px',
  },
}));

export default useStyles;
